import React, { useEffect, useState } from "react";
import { Lock, Eye, EyeOff, Upload } from "lucide-react";

let abrir = null;

export function pedirContrasenaPdf(opts) {
  return new Promise((resolve) => (abrir ? abrir({ ...opts, resolve }) : resolve(null)));
}

export function ContrasenaPdfDialog() {
  const [req, setReq] = useState(null);
  const [pwd, setPwd] = useState("");
  const [ver, setVer] = useState(false);
  useEffect(() => { abrir = (r) => { setPwd(""); setVer(false); setReq(r); }; return () => { abrir = null; }; }, []);
  if (!req) return null;
  const cerrar = (v) => { req.resolve(v); setReq(null); };
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4" data-testid="dialogo-pdf-protegido">
      <form onSubmit={(e) => { e.preventDefault(); if (pwd) cerrar(pwd); }} className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600"><Lock className="h-5 w-5" /></span>
          <div className="min-w-0">
            <p className="font-display text-base font-semibold text-slate-900">PDF protegido con contraseña</p>
            <p className="mt-1 text-sm text-slate-600">{req.mensaje}</p>
            {req.archivo && <p className="mt-1 break-all text-xs text-slate-400">{req.archivo}</p>}
          </div>
        </div>
        {req.error && <p className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="pdf-contrasena-error">La contraseña ingresada no abre el documento. Inténtalo de nuevo.</p>}
        <div className="relative mt-4">
          <input autoFocus type={ver ? "text" : "password"} value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Contraseña del PDF"
            className="w-full rounded-lg border border-slate-300 px-3 py-2.5 pr-10 text-sm focus:border-vino-500 focus:outline-none focus:ring-2 focus:ring-vino-100" data-testid="pdf-contrasena-input" />
          <button type="button" onClick={() => setVer((v) => !v)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-400" aria-label="Mostrar contraseña" data-testid="pdf-contrasena-ver">
            {ver ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
        <p className="mt-2 text-xs text-slate-500">{req.nota || "Roge guarda la contraseña cifrada. El archivo original no se modifica."}</p>
        <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button type="button" onClick={() => cerrar(null)} className="flex items-center justify-center gap-2 rounded-lg border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid="pdf-contrasena-cancelar">
            <Upload className="h-4 w-4" /> {req.textoCancelar || "Cargar otro archivo"}
          </button>
          <button type="submit" disabled={!pwd} className="rounded-lg bg-vino-700 px-4 py-2 text-sm font-semibold text-white hover:bg-vino-800 disabled:opacity-50" data-testid="pdf-contrasena-confirmar">
            {req.textoConfirmar || "Usar contraseña"}
          </button>
        </div>
      </form>
    </div>
  );
}
